<section>
  @if (data.image; as image) {
    @let textSeoShowFullText = !!data.textSeo.showFullText;
    <div
      [class.desk:h-[706px]]="!textSeoShowFullText"
      [class.grid]="textSeoShowFullText"
      [class.h-[948px]]="!textSeoShowFullText"
      class="mask-curve-top relative">
      <app-image
        [class.col-start-1]="textSeoShowFullText"
        [class.row-start-1]="textSeoShowFullText"
        [image]="image"
        [isPriority]="!isImageInPreviousBlocks"
        [pregenerationSize]="{ width: 1280 }"
        class="z-0 object-cover" />
      <div
        [class.absolute]="!textSeoShowFullText"
        [class.col-start-1]="textSeoShowFullText"
        [class.pt-12]="textSeoShowFullText"
        [class.row-start-1]="textSeoShowFullText"
        class="inset-0 z-10 flex items-end justify-center pb-12">
        <div class="flex flex-col gap-y-1">
          @if (data.title; as title) {
            <app-title [title]="title" class="pb-5 text-center text-white" size="h1" />
          }
          @if (data.textSeo; as textSeo) {
            <app-text-seo [hasScroll]="!textSeoShowFullText" [textSeo]="textSeo" />
          }
        </div>
      </div>
    </div>
  }
</section>
